export enum Tab {
  Fabrics = 'fabrics',
  Options = 'options',
  Accessories = 'accessories',
  Summary = 'summary',
}
